
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pay/instore",
      function () {
        return require("private-next-pages/pay/instore/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pay/instore"])
      });
    }
  